import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["el-select-dropdown", [{ 'is-multiple': _ctx.isMultiple }, _ctx.popperClass]]),
    style: _normalizeStyle({ minWidth: _ctx.minWidth })
  }, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 6))
}